import {
    trackEvent,
    eventNameConstants,
    interactionTypeConstants,
    stepInteractionConstants,
} from 'dibs-tracking';

const trackingObj = {
    action: 'email a friend sent',
    category: 'email a friend',
    value: 0,
    eventName: eventNameConstants.EVENT_SHARE,
    step_interaction_name: stepInteractionConstants.STEP_INTERACTION_EMAIL_A_FRIEND_SENT,
};

export const trackPdpEvent = ({ itemId }) => {
    const label = `item|${itemId}`;
    trackEvent({
        ...trackingObj,
        label,
        interaction_type: interactionTypeConstants.INTERACTION_TYPE_PDP,
        step_type: `item|${itemId}`,
    });
};

export const trackFavoritesEvent = ({ type = 'item', itemCount, hasNote = false }) => {
    let label = type;
    let value = 0;

    if (type === 'item' && itemCount > 1) {
        label = 'multiple items';
    }

    if (hasNote) {
        value = 1;
    }

    if (label) {
        trackEvent({ ...trackingObj, label, value, step_type: label });
    }
};
